import { OptionsFilter } from '../../../Domain/Entities/filter-list.interface';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';
import { select, Store } from '@ngrx/store';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';
import { selectRoleState } from 'projects/access-control/src/app/Infrastructure/Store/role/role.selectors';
import { deleteRole, getFilterRole, getRole } from 'projects/access-control/src/app/Infrastructure/Store/role/role.actions';
import { TranslateService } from '@mangosoft/mango-layout';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import { ModalNewRoleComponent } from 'projects/access-control/src/app/UI/components/modal-new-role/modal-new-role.component';
import filtersRoleTable from './filtersRoleTable';
import FilterList, { FilterValues } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { FilterTablePipe } from 'projects/access-control/src/app/Infrastructure/pipes/filter-table.pipe';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { FiltersService } from 'projects/access-control/src/app/Infrastructure/Services/filters/filters.service';

interface TranslateRole extends DataTranslatePages {
	delete: string;
	bulkDeletes: string;
	textResource: string;
	table: {
		action: string;
		columns: { name: string; label: string }[];
		search: FilterList[];
	};
	columnsFilter: { name: string; label: string }[];
}
@Component({
	selector: 'app-roles',
	templateUrl: './roles.component.html',
	styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit, OnDestroy {
	title = 'Roles';
	elementsDeleteModal = '';
	rows: IRole[] = [];
	rowsFilters: IRole[] = [];
	modeColum!: any;
	selected: IRole[] = [];
	elementDelete: IRole = {} as IRole;
	selectionType = SelectionType;
	isLoading = true;
	valueModalDelete = '';
	disabledRefresh = true;
	nameModalDelete = 'modalAlertDeleteElement';
	filterResults: FilterValues[] = [] as FilterValues[];
	openAlert: boolean = false;
	translateRoles: TranslateRole = {} as TranslateRole;
	subscriptionTranslate!: Subscription;
	subscriptionRole!: Subscription;
	filterList: FilterList[] = filtersRoleTable;
	pagination: DataPagination = {} as DataPagination;
	textModal = 'modalAlertDeleteElement';
	url = '';
	activeFilter: boolean = false;
	columnsFilter: OptionsFilter[] = [
		{ name: 'name', label: 'Name' },
		{ name: 'client', label: 'Client' },
	];
	columns: any[] = [
		{ name: 'name', label: 'Name' },
		{ name: 'client', label: 'Client' },
		{ name: 'permissions', label: 'Perrmisions' },
		{ name: 'Status', label: 'Status' },
	];
	optionsTable: OptionsTable[] = [
		{
			value: 'update',
			icon: 'edit',
		},
		{
			value: 'delete',
			icon: 'delete',
		},
	] as OptionsTable[];

	constructor(
		private store: Store,
		private translateService: TranslateService,
		public dialog: MatDialog,
		private filter: FilterTablePipe,
		private filterService: FiltersService
	) {}

	ngOnInit(): void {
		this.getRoles();
		this.getTranslate();
		this.store.dispatch(getRole({ paginationTo: 1 }));
		this.modeColum = ColumnMode.force;
	}

	getRoles() {
		this.subscriptionRole = this.store.pipe(select(selectRoleState)).subscribe({
			next: ({ roles, pagination, loading }) => {
				this.isLoading = loading;
				if (roles.length > 0) {
					this.rows = roles;
					this.pagination = pagination;
					this.rows = this.rows.filter(
						(role) =>
							role.sk !== '01GVNV2C0CMDDKXA0AZ9WM4M3D:current' &&
							role.pk != '01G7C3VPJQ7WPGN3WWAGABV8ZR:role'
					);
					this.orderRows();
				}
			},
			complete: () => {
				// this.isLoading = false;
			},
		});
	}

	orderRows() {
		this.rows = this.rows.map((role) => {
			const { permissions, status, ...rolesData } = role;
			return {
				...rolesData,
				permissions: `${role.resources.length} ${this.translateRoles.textResource}${
					role.resources.length === 1 ? '' : 's'
				} `,
				status: 'Active',
				client: role.client ? role.client.toString() : '',
			};
		});
		this.rowsFilters = this.rows;
	}

	filterSelected(options: OptionsFilter[]) {
		this.url = this.filterService.createUrl(options);
		if (this.url.length > 0) {
			this.activeFilter = true;
			this.store.dispatch(getFilterRole({ url: this.url }));
		} else {
			this.activeFilter = false;
			this.store.dispatch(getRole({ paginationTo: 1 }));
		}
	}

	getFilterValues(filter: FilterValues[]) {
		this.filterResults = filter;
		this.rowsFilters = this.filter.transform(this.rows, filter) as IRole[];
	}
	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateRoles = data.pages.roles;
			this.columnsFilter = this.translateRoles.columnsFilter;
			this.filterList = this.translateRoles.table.search;
			this.columns = this.translateRoles.table.columns;
			this.orderRows();
		});
	}

	emitNavigation(paginationTo: number) {
		if (this.activeFilter) {
			this.store.dispatch(getFilterRole({ url: `${this.url}&_size=10&_page=${paginationTo}` }));
		} else {
			this.store.dispatch(getRole({ paginationTo }));
		}
	}
	actions(event: any) {
		if (event.action === 'update') {
			this.openDialogRole(event.action, event.value);
		} else {
			this.textModal = 'modalAlertDeleteElement';
			this.elementDelete = event.value;
			this.valueModalDelete = 'delete';
			this.elementsDeleteModal = `${this.translateRoles.delete} '${event.value.name}'`;
			this.openAlert = true;
		}
	}
	refreshData(event: boolean) {
		this.isLoading = event;
	}

	buttonAction(option: string) {
		if (option === 'refresh') {
			this.store.dispatch(getRole({ paginationTo: 1 }));
			this.disabledRefresh = true;
		} else {
			this.elementsDeleteModal = '';
			if (this.selected.length > 0) {
				this.textModal = 'modalAlertDeleteElement';
				this.elementsDeleteModal =
					this.selected.length > 1
						? `${this.selected.length} ${this.translateRoles.bulkDeletes}`
						: `${this.translateRoles.delete} '${this.selected[0]?.name}'`;
			} else {
				this.textModal = 'modalAlertDeleteNoSelected';
			}

			this.valueModalDelete = 'bulkDelete';
			this.openAlert = true;
		}
	}
	onSelect({ selected }: any) {
		this.selected.splice(0, this.selected.length);
		selected.forEach((element: any) => {
			this.selected.push(element);
		});
	}
	getRowClass(row: any) {
		return {
			'sensd-class': row.name.toLowerCase() !== 'Send'.toLowerCase(),
		};
	}

	getCellClass({ row, column, value }: any): any {
		return {
			'send-class':
				row.status.toLowerCase() === 'Active'.toLowerCase() &&
				column.name.toLowerCase() === 'Status'.toLowerCase(),
			'draft-class': row.status === 'DRAFT' && column.name === 'Status',
			'progress-class': row.status === 'IN PROGRESS' && column.name === 'Status',
			'pending-class': row.status === 'SCHEDULED' && column.name === 'Status',
		};
	}
	openDialogRole(type = 'create', value: IRole = {} as IRole): void {
		const dialogRef = this.dialog.open(ModalNewRoleComponent, {
			height: '80vh',
			minHeight: '650px',
			maxWidth: '950px',
			data: { type, value },
		});
		dialogRef.afterClosed().subscribe((res) => {});
	}
	closeModalAlert(event: any) {
		if (event.resp) {
			if (this.valueModalDelete === 'delete') {
				const ids = [{ sk: this.elementDelete.sk, pk: this.elementDelete.pk }];
				this.store.dispatch(deleteRole({ ids }));
			} else {
				const ids: IPkSk[] = this.selected.map((role) => {
					return {
						pk: role.pk,
						sk: role.sk,
					};
				});
				this.store.dispatch(deleteRole({ ids }));
			}
		}
		this.openAlert = false;
		this.elementDelete = {} as IRole;
		this.selected = [];
		this.elementsDeleteModal = '';
	}
	ngOnDestroy() {
		this.subscriptionRole?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
